export interface MessageBoxSettings {
    id: string;
    type: MessageBoxType;
    caption: String;
    message: String;
}

export interface MessageBoxResult {
    id: String;
    result: MessageBoxResultType;
}

export const enum MessageBoxType {
    yesNo,
    okCancel,
    yesNoCancel,
}

export const enum MessageBoxResultType {
    yes,
    ok,
    no,
    cancel,
}



// WEBPACK FOOTER //
// ./src/app/components/messagebox/messagebox.config.ts